import { nameMinLength, nameMaxLength } from "../api/config/parameters";
import { availableLanguages } from "./parameters";
import { deparseDescriptions } from "./helpers/meta";
import { IPlan } from "./types";

// Type guards, so that what they check is also what the compiler knows afterwards.
export const isObject = (val: unknown): val is Record<string, unknown> => typeof val === "object" && !Array.isArray(val);
export const isArray = (val: unknown): val is unknown[] => typeof val === "object" && Array.isArray(val);
export const isBoolean = (val: unknown): val is boolean => typeof val === "boolean";
export const isString = (val: unknown): val is string => typeof val === "string";
export const isNumber = (val: unknown): val is number => typeof val === "number";
export const isProperLength = (val: { length: number }) => val.length >= nameMinLength && val.length <= nameMaxLength;
export const isTaskType = (val: string) =>
    val === "rhytSorting" ||
    val === "rhytKnock" ||
    val === "handSign" ||
    val === "barSorting" ||
    val === "barSorting2" ||
    val === "barline" ||
    val === "singing" ||
    val === "melodyTable" ||
    val === "tonesetStaff" ||
    val === "flow" ||
    val === "rhytName" ||
    val === "rhytNotation" ||
    val === "solfaName" ||
    val === "piano" ||
    val === "intervals" ||
    val === "chords3" ||
    val === "subScore" ||
    val === "embed";

const isSupportedLanguages = (list: string[]) => {
    for (let lang of list) {
        if (![...availableLanguages, "en"].includes(lang)) return false;
    }
    return true;
};

export const isValidPlanTitle = (titles: IPlan["name"]) => {
    if (!isObject(titles)) return false;
    if (!isSupportedLanguages(Object.keys(titles))) return false;
    for (let title of Object.values(titles)) {
        if (!isString(title) || !isProperLength(title)) return false;
    }
    return true;
};
export const isValidPlanDescription = (descriptions: IPlan["description"]) => {
    const deparsedDescriptions = deparseDescriptions(descriptions);
    if (!isObject(deparsedDescriptions)) return false;
    if (!isSupportedLanguages(Object.keys(deparsedDescriptions))) return false;
    for (let description of Object.values(deparsedDescriptions)) {
        if (!isString(description) || description.length > 400) return false;
    }
    return true;
};
